import React from 'react';
import InvoiceFilter from './Invoice/InvoiceFilter';
import NotaFilter from './Nota/NotaFilter';
import STInvoiceFilter from './STInvoice/STInvoiceFilter';

const PrintFilterDisplay = ({ option, data, onClose }) => {
  switch (option) {
    case 'invoice':
      return <InvoiceFilter data={data} onClose={onClose} />;
    case 'serahTerimaNota':
      return <NotaFilter data={data} onClose={onClose} />;
    case 'serahTerimaInvoice':
      return <STInvoiceFilter data={data} onClose={onClose} />;
    default:
      return null;
  }
};

export default PrintFilterDisplay;
